import { render } from "./ComparativeTVPLowlights.vue?vue&type=template&id=1fcb530a"
import script from "./ComparativeTVPLowlights.vue?vue&type=script&lang=js"
export * from "./ComparativeTVPLowlights.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__